import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  CardContent,
  TextField,
  Button,
  // Table,
  // TableRow,
  // TableHead,
  // TableCell,
  Typography,
  Tooltip,
  Grid
} from "@material-ui/core";
import SelectSearchable from "components/Select";
import CloudUpload from "@material-ui/icons/CloudUpload";
import Delete from "@material-ui/icons/Delete";
import Refresh from "@material-ui/icons/Refresh";
import ExitToApp from "@material-ui/icons/ExitToApp";
import Add from "@material-ui/icons/Add";
import AgGridWrapper from "./AgGridWrapper";
//
// const Log = ({ log }) => (
//   <Table>
//     <TableHead>
//       <TableRow>
//         <TableCell>Date</TableCell>
//         <TableCell>Samples</TableCell>
//         <TableCell>Fulfilled</TableCell>
//         <TableCell>Failed</TableCell>
//       </TableRow>
//     </TableHead>
//     {log.slice(-1).map(entry => (
//       <TableRow>
//         <TableCell>{entry.date}</TableCell>
//         <TableCell>{entry.total}</TableCell>
//         <TableCell>{entry.fulfilled}</TableCell>
//         <TableCell>{entry.failed}</TableCell>
//       </TableRow>
//     ))}
//   </Table>
// );

const ElabBulkLayout = props => {
  const {
    user,
    username,
    password,
    loginButtonClick,
    isFetchingLogin,
    logoutButtonClick,
    sampleTypes,
    sampleType,
    onSampleTypeChange,
    isFetchingSampleTypes,
    uploadData,
    addRows,
    clearData,
    setUsername,
    setPassword,
    elabUserFailed,
    storageLocations,
    storageLocation,
    onStorageLocationChange,
    isFetchingStorageLocations,
    setCellToStorageLocation,
    refreshELabData
    // log
  } = props;
  //  {user && log.length ? <Log log={log} /> : null}
  let title = "eLAB Bulk Uploader";
  if (user) title += ` - ${user}`;
  const actionButtonsStyle = { paddingTop: "5px" };
  const enterKeyHandler = ev => {
    if (ev.key === "Enter") {
      ev.preventDefault();
      loginButtonClick();
    }
  };
  return (
    <Card>
      <CardHeader title={title} style={{ marginBottom: 30 }} />
      <CardContent>
        <Grid container spacing={8}>
          {!user && elabUserFailed && (
            <Typography
              variant="button"
              style={{ paddingLeft: 35, color: "#ff0f0f" }}
            >
              Login failed, try credentials again.
            </Typography>
          )}

          {!user && (
            <Grid item xs={12}>
              <Typography paragraph>
                Welcome to the eLAB bulk sample uploader. Please enter your eLAB
                username and password to start.
              </Typography>
              <Grid item xs={4}>
                <TextField
                  style={{ margin: "10px" }}
                  fullWidth
                  label="Username"
                  onKeyPress={enterKeyHandler}
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  style={{ margin: "10px" }}
                  fullWidth
                  label="Password"
                  type="password"
                  value={password}
                  onKeyPress={enterKeyHandler}
                  onChange={e => {
                    setPassword(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <Button
                  style={{ margin: "10px" }}
                  onClick={loginButtonClick}
                  color="primary"
                  variant="contained"
                  disabled={isFetchingLogin}
                >
                  {isFetchingLogin ? "Logging In..." : "Log in"}
                </Button>
              </Grid>
            </Grid>
          )}

          {user && (
            <React.Fragment>
              <Grid item xs={5}>
                <SelectSearchable
                  style={{ zIndex: 999 }}
                  label={
                    <span>
                      Sample Type<font color="red"> *</font>
                    </span>
                  }
                  placeholder="Pick a sample type"
                  options={sampleTypes.map(e => ({
                    label: e.name,
                    value: e.sampleTypeID
                  }))}
                  value={sampleType}
                  onChange={onSampleTypeChange}
                  isLoading={isFetchingSampleTypes}
                />
              </Grid>
              <Grid item xs={2} style={actionButtonsStyle}>
                <Tooltip title="Logout of your eLAB user">
                  <Button
                    fullWidth
                    onClick={logoutButtonClick}
                    variant="contained"
                  >
                    Logout {} <ExitToApp />
                  </Button>
                </Tooltip>
              </Grid>
              <Grid item xs={3} style={actionButtonsStyle}>
                <Tooltip title="You can't paste more data than there are rows, you have to add them first">
                  <span>
                    <Button
                      fullWidth
                      disabled={!sampleType}
                      onClick={() => addRows(1000)}
                      variant="contained"
                    >
                      Add 1000 Rows <Add />
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
              <Grid item xs={2} style={actionButtonsStyle}>
                <Tooltip title="Clear selected cells">
                  <span>
                    <Button
                      fullWidth
                      onClick={clearData}
                      disabled={!sampleType}
                      variant="contained"
                    >
                      Clear Selection
                      <Delete />
                    </Button>
                  </span>
                </Tooltip>
              </Grid>

              <Grid item xs={5}>
                <SelectSearchable
                  label="Location finder"
                  // placeholder="Pick a sample type"
                  options={storageLocations}
                  value={storageLocation}
                  onChange={onStorageLocationChange}
                  isLoading={isFetchingStorageLocations}
                  disabled={!sampleType}
                />
              </Grid>
              <Grid item xs={3}>
                <Tooltip title="First pick a location then click this to set cell to that location">
                  <span>
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={setCellToStorageLocation}
                      disabled={!storageLocation}
                    >
                      Set Row(s) To Location
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
              <Grid item xs={2} style={actionButtonsStyle}>
                <Tooltip title="Reload eLAB data, eg Sample types & Locations">
                  <Button
                    fullWidth
                    onClick={refreshELabData}
                    variant="contained"
                  >
                    Refresh eLAB data
                    <Refresh />
                  </Button>
                </Tooltip>
              </Grid>
              <Grid item xs={2} style={actionButtonsStyle}>
                <Tooltip title="Send this data to eLAB. Must set Sample Type first.">
                  <span>
                    <Button
                      fullWidth
                      disabled={!user || !sampleType}
                      onClick={uploadData}
                      color="primary"
                      variant="contained"
                    >
                      Upload Data <CloudUpload style={{ marginLeft: "3px" }} />
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
              <Grid item xs={12}>
                <AgGridWrapper
                  editable
                  // onStorageLocationChange={() => {}}
                  {...props}
                />
              </Grid>
            </React.Fragment>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};
const sampleTypeObjShape = PropTypes.shape({
  backgroundColor: PropTypes.string,
  defaultQuantity: PropTypes.number,
  defaultQuantityType: PropTypes.string,
  defaultThresholdAction: PropTypes.string,
  defaultUnit: PropTypes.string,
  defaultUnitShort: PropTypes.string,
  deleted: PropTypes.bool,
  description: PropTypes.string,
  foregroundColor: PropTypes.string,
  meta: PropTypes.shape({}),
  groupID: PropTypes.number,
  name: PropTypes.string,
  quantityRequired: PropTypes.bool,
  sampleTypeID: PropTypes.number,
  thresholdEnables: PropTypes.bool,
  unserID: PropTypes.number
});
ElabBulkLayout.propTypes = {
  // onSelectCalvert: PropTypes.func.isRequired,
  // onSelectQuadra: PropTypes.func.isRequired,
  // onSelectJohnstone: PropTypes.func.isRequired,

  user: PropTypes.string,
  username: PropTypes.string,
  password: PropTypes.string,
  loginButtonClick: PropTypes.func.isRequired,
  isFetchingLogin: PropTypes.bool.isRequired,
  logoutButtonClick: PropTypes.func.isRequired,
  sampleTypes: PropTypes.arrayOf(PropTypes.shape({ sampleTypeObjShape })),
  sampleType: PropTypes.string,
  onSampleTypeChange: PropTypes.func.isRequired,
  isFetchingSampleTypes: PropTypes.bool.isRequired,
  uploadData: PropTypes.func.isRequired,
  addRows: PropTypes.func.isRequired,
  clearData: PropTypes.func.isRequired,
  setUsername: PropTypes.func.isRequired,
  setPassword: PropTypes.func.isRequired,
  elabUserFailed: PropTypes.bool.isRequired,
  storageLocations: PropTypes.arrayOf(PropTypes.object).isRequired,
  storageLocation: PropTypes.number,
  onStorageLocationChange: PropTypes.func.isRequired,
  isFetchingStorageLocations: PropTypes.bool.isRequired,
  setCellToStorageLocation: PropTypes.func.isRequired,
  refreshELabData: PropTypes.func.isRequired,
  log: PropTypes.arrayOf(PropTypes.object).isRequired
};
ElabBulkLayout.defaultProps = {
  storageLocation: null,
  sampleType: "",
  sampleTypes: [],
  user: null,
  username: "",
  password: ""
};
export default ElabBulkLayout;
